import Cookies from 'js-cookie';

export const languageCookieName = 'language';

export default function savePreferredLanguage(language: string) {
  Cookies.set(languageCookieName, language, { expires: 365 });
}
